export var KeyType;
(function (KeyType) {
    KeyType["RSA"] = "rsa";
    KeyType["Edwards"] = "ed25519";
    KeyType["BLS"] = "bls12-381";
})(KeyType || (KeyType = {}));
//# sourceMappingURL=types.js.map